(function () {
  function animateCounter(el) {
    var target = parseFloat(el.dataset.target);
    if (isNaN(target) || target <= 0) return;
    var display = el.textContent;
    var current = 0, i = 0, steps = 40, inc = target / steps;
    var tick = function () {
      i++;
      current = Math.min(target, current + inc);
      el.textContent = current.toFixed(2).replace('.', ',') + ' €';
      if (i < steps) requestAnimationFrame(tick);
      else el.textContent = display;
    };
    requestAnimationFrame(tick);
  }

  function initRechner() {
    // Toggle
    document.querySelectorAll('[data-rechner-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rechner = btn.closest('[data-rechner]');
        var details = rechner.querySelector('[data-rechner-details]');
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.classList.toggle('is-open', !open);
        details.setAttribute('aria-hidden', open ? 'true' : 'false');
      });
    });

    // Counter on scroll
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.fifteen-rechner__savings-amount[data-target]').forEach(function (c) {
      observer.observe(c);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRechner);
  } else {
    initRechner();
  }
})();
